import React from "react";
import "./achievementComponent.css";
import OptimizedSlideshow from '../projects/OptimizedSlideshow';

import image1 from "./images/hackorg1.jpeg";
import image2 from "./images/hackorg2.jpeg" ;
import image3 from "./images/hackorg3.jpeg" ;
import image4 from "./images/hackorg4.jpeg" ;
import image5 from "./images/hackorg5.jpeg";
import image6 from "./images/hackorg6.jpeg";



const AIhackflow = () => {
    const images = [image1,image5,image2, image3, image4, image6];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">AI HackFlow 2024</h2>
        <span className="section__subtitle">Technical Assistant & Organizer</span>
        <OptimizedSlideshow mediaItems={images} />
        
        <div className="about__container container grid">
           

            <div className="text__container1">
                <h3 className="title">Description:</h3>
                <div className="achievement__content">
                    <p className='redRadio__text'>
                        🌟 Mentored teams at the <strong>AI Hackflow "West World Edition"</strong> hackathon, guiding participants through <strong>ideation, AI concept application, and project execution</strong> over a 24-hour event. 🚀
                    </p>
                    <p className='redRadio__text'>
                        💡 Provided hands-on support in <strong>machine learning</strong>, problem-solving, and team collaboration. Helped foster innovation and perseverance, resulting in <strong>two teams reaching the Top 8</strong> and <strong>one team advancing to the Top 3</strong>.
                    </p>
                    <p className='redRadio__text'>
                        🙌 Contributed to event logistics and ensured a vibrant, productive environment — empowering the next generation of AI innovators. ✨
                    </p>
                </div>
            </div>
        </div>
    </section>
    );
};

export default AIhackflow;
